import {
  GET_DEFAULT_VOICE_PROMPT_REQUEST,
  GET_DEFAULT_VOICE_PROMPT_SUCCESS,
  GET_DEFAULT_VOICE_PROMPT_FAILURE,
} from '../actions/defaultVoicePromptActions';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

export default function defaultVoicePrompt(state = initialState, action) {
  switch (action.type) {
    case GET_DEFAULT_VOICE_PROMPT_REQUEST:
      return {
        loading: true,
        error: null,
        data: null,
      };
    case GET_DEFAULT_VOICE_PROMPT_SUCCESS:
      return {
        loading: false,
        error: null,
        data: action.payload,
      };
    case GET_DEFAULT_VOICE_PROMPT_FAILURE:
      return {
        loading: false,
        error: action.error,
        data: null,
      };

    default:
      return state;
  }
}

